import React from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import { BillDocumentView } from './BillDocumentView';
import { BillReconcileView } from './BillReconcileView';

/**
 * Unified bill page — document view by default; ?mode=reconcile for
 * side-by-side PO ↔ invoice reconciliation.
 *
 * v1.45 — key on the bill id so the heavy per-bill reconcile state fully
 * resets when navigating between sibling bills on the same PO (the route
 * reuses this component, so without a key the previous bill's lines linger).
 */
export const BillPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { id } = useParams<{ id: string }>();
  const reconcileMode = searchParams.get('mode') === 'reconcile';
  return reconcileMode
    ? <BillReconcileView key={id} />
    : <BillDocumentView key={id} />;
};

export default BillPage;
